import {ReactComponent as UniShirazIcon} from './uniShiraz.svg'

function UniShiraz() {
  return <UniShirazIcon />
}

export default UniShiraz
